import { Outlet, createRootRoute } from "@tanstack/react-router";
import { Rail } from "../components/Rail";
import { useReveal } from "../lib/useReveal";
import { ScrollProgress } from "../components/ScrollProgress";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  useReveal();
  return (
    <div className="wrap">
      <ScrollProgress />
      <Rail />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
